<script>
  import { onMount, onDestroy } from 'svelte';
  import { fade, fly } from 'svelte/transition';
  import {
    getAdapterData,
    getSuggestionData,
    getConcurrentData,
    headerSelectWithProps,
    headerTrigger,
    headerSuggesterTrigger,
    SELECT_SOURCE,
    ACTIONS,
    NAVIGATE_OPTIONS,
    CALL_OPTIONS,
    SELECT_OPTIONS,
  } from './entities/header_triggers';
  import { clickOutside } from './directives/click-outside';

  // Header declarations
  const BREAK_TABLET = 1024;
  const TIME_TO_HIDE_SUGGESTIONS = 300;
  let subscriptions = [];

  let headerInfo = {};
  let currentHeader = {};
  let closedText = '';
  let searchText = '';

  // Lifecycle Methods
  onMount(() => {
    searchText = getParamValue('query');
    subscriptions.push(
      getAdapterData().subscribe((headerNgData) => {
        if (!!headerNgData) {
          headerInfo = headerNgData;
          currentHeader =
            !!headerInfo && !!headerInfo.type ? headerInfo.type : {};
        }
      }),
      getSuggestionData().subscribe((headerNgSuggestData) => {
        if (!!headerNgSuggestData && !hideSuggestions) {
          restaurantSugg = headerNgSuggestData.restaurantSuggestions || [];
          globalSugg = headerNgSuggestData.globalSuggestions || [];
        }
      }),
      getConcurrentData().subscribe((headerNgConcurrentData) => {
        if (!!headerNgConcurrentData) {
          placeHolderText = headerNgConcurrentData.placeHolderText || '';
          currentStoreType = headerNgConcurrentData.currentStoreType;
          clearDataOnCurrentStateChange();
        }
      })
    );
  });

  onDestroy(() => {
    if (!!subscriptions.length) {
      subscriptions.forEach((sub) => !!sub && sub.unsubscribe());
    }
  });

  $: if (!!headerInfo && !!Object.entries(headerInfo).length) {
    initData();
  }

  const initData = () => {
    if (headerInfo.url) {
      currentUrl = headerInfo.url;
    }
    if (headerInfo.storeTypes) {
      _storeTypes = headerInfo.storeTypes.items;
      _storeTypesBase = _storeTypes;
    }
    if (!headerInfo.parentStoreType) {
      assignFirstStoreAsCurrent();
    }
    if (headerInfo.login) {
      isLoggedIn = headerInfo.login.isLoggedIn;
      logInTitle = headerInfo.login.logInTitle;
      signUpTitle = headerInfo.login.signUpTitle;
      logOutTitle = headerInfo.login.logOutTitle;
      isPrime = headerInfo.login.isPrime;
      userName = headerInfo.login.userName;
      welcomeText = headerInfo.login.welcomeText;
      userUrl = headerInfo.login.userUrl;
      primeUrl = headerInfo.login.primeUrl;
      subscribeUrl = headerInfo.login.subscribeUrl;
      rappiCredits = headerInfo.login.rappiCredits;
      rappiCreditsTitle = headerInfo.login.rappiCreditsTitle;
      menuOptions = headerInfo.login.menuOptions;
    }
    if (headerInfo.basket) {
      productBasketNumber = headerInfo.basket.productsNumber;
    }
    if (headerInfo.texts) {
      closedText = headerInfo.texts.closed;
      preferencesText = headerInfo.texts.preferences;
      storesTitle = headerInfo.texts.stores;
      seeMoreText = headerInfo.texts.seeMore;
      specialBackText = headerInfo.texts.goBack;
      primeFirst = headerInfo.texts.primeFirst;
      primeSecond = headerInfo.texts.primeSecond;
      primeSubtitle = headerInfo.texts.primeSubtitle;
    }
    if (headerInfo.specialStore) {
      isOnSpecialStore = headerInfo.specialStore.isOnSpecialStore;
      specialStoreName = headerInfo.specialStore.storeName;
    }
    parentStoreType = headerInfo.parentStoreType;
    ngRappiMobile = headerInfo.isMobile;
    errorImg = headerInfo.errorImage;
    formattedAddress = headerInfo.address;
    showBackBtn = currentHeader.showMainBack;
    footerList = headerInfo.footerList;
  };

  // Header Logic
  let errorImg = '';
  let currentWidth;
  let ngRappiMobile = false;
  let isMobile;
  let showBackBtn = false;
  let specialBackText = '';
  $: isMobile = currentWidth <= BREAK_TABLET || ngRappiMobile;

  const clearDataOnCurrentStateChange = () => {
    clearSuggestions();
    if (isMobile) showMobileNav = false;
    showDropDown = false;
  };

  const navigateToView = (opt) => {
    clearText();
    if (isMobile) showMobileNav = false;
    headerTrigger(ACTIONS.NAVIGATE, opt);
  };
  const goSpecialBack = () => navigateToView(NAVIGATE_OPTIONS.SPECIAL_BACK);
  const goBack = () => navigateToView(NAVIGATE_OPTIONS.BACK);
  const goToHome = () => navigateToView(NAVIGATE_OPTIONS.HOME);

  // Search Logic
  $: showSuggestions =
    ((!!globalSugg && !!globalSugg.length) ||
      (!!restaurantSugg && !!restaurantSugg.length)) &&
    enableSuggestions;
  $: focusInput ? (enableSuggestions = true) : callTimeOut();

  let enableSuggestions = true;
  let timeOutHideSuggest, searchStyle;
  let hideSuggestions = false;
  const callTimeOut = () => {
    timeOutHideSuggest = setTimeout(
      () => (enableSuggestions = false),
      TIME_TO_HIDE_SUGGESTIONS
    );
    return timeOutHideSuggest;
  };
  let restaurantSugg = [];
  let globalSugg = [];
  let placeHolderText;
  let showMblSearch = false;
  let focusInput = false;
  $: if (isMobile) {
    if (!showMblSearch) {
      searchStyle = 'search-container hidden';
    } else {
      searchStyle = 'search-container focus mbl';
    }
  } else {
    searchStyle = 'search-container focus';
  }

  const toogleMblSearch = () => (showMblSearch = !showMblSearch);
  const toogleFocus = () => (focusInput = !focusInput);

  const searchOnRappi = () => {
    headerTrigger(ACTIONS.SEARCH, searchText);
    hideSuggestions = true;
    clearSuggestions();
  };
  const fetchSuggestions = () =>
    headerSuggesterTrigger(ACTIONS.SEARCH_SUGGESTIONS, searchText);
  const clearText = () => {
    searchText = '';
    clearSuggestions();
  };
  const toogleSuggestions = () => (enableSuggestions = !enableSuggestions);
  const clearSuggestions = () => {
    restaurantSugg = [];
    globalSugg = [];
  };
  const selectSuggestion = (item, source) => {
    clearTimeout(timeOutHideSuggest);
    headerSelectWithProps(
      ACTIONS.SELECT,
      SELECT_OPTIONS.SUGGESTION,
      item,
      source
    );
    searchText = item;
    toogleSuggestions();
    clearSuggestions();
  };
  const handleSearch = (event) => {
    let keyCode = event.code;
    if (keyCode === 'Enter') {
      searchOnRappi();
    } else {
      hideSuggestions = false;
      fetchSuggestions();
    }
  };

  // StoreTypes Logic
  let _storeTypes = [];
  let _storeTypesBase = [];
  let currentStoreType;
  let parentStoreType;
  let showDropDown = false;
  let showMobileNav = false;
  let currentStore, isOnSpecialStore, specialStoreName;
  $: showMobileNav
    ? headerTrigger(ACTIONS.CALL, CALL_OPTIONS.FREEZE_BG)
    : headerTrigger(ACTIONS.CALL, CALL_OPTIONS.UNFREEZE_BG);
  $: _mblStoreTypes =
    !!_storeTypes && !!_storeTypes.length && _storeTypes.slice(0, 5);
  $: if (!!_storeTypes && !!_storeTypes.length) {
    const filteredStoreTypes = [..._storeTypesBase].reduce((prev, curr) => {
      curr.type !== currentStoreType ? prev.push(curr) : (currentStore = curr);
      return prev;
    }, []);
    _storeTypes = filteredStoreTypes;
  }
  $: if (!!parentStoreType) {
    currentStoreType = parentStoreType;
  }
  $: if (!!isOnSpecialStore) {
    currentStoreType = specialStoreName;
  }
  const assignFirstStoreAsCurrent = () => {
    if (!currentStore){
      currentStore = !!_storeTypes && !!_storeTypes.length && _storeTypes[0];
    }
  };
  const toogleMobileNav = () => (showMobileNav = !showMobileNav);
  const toogleDropDown = () => (showDropDown = !showDropDown);
  const selectStore = (store) => {
    clearText();
    if (isMobile) {
      showMobileNav = false;
      headerSelectWithProps(
        ACTIONS.SELECT,
        SELECT_OPTIONS.STORE_TYPE,
        store,
        SELECT_SOURCE.STORE_TYPE
      );
    } else {
      const updatedList = [..._storeTypesBase].filter(
        (i) => i.name !== store.name
      );
      updatedList.unshift(store);
      _storeTypes = updatedList;
      currentStore = store;
      headerSelectWithProps(
        ACTIONS.SELECT,
        SELECT_OPTIONS.STORE_TYPE,
        store,
        SELECT_SOURCE.STORE_TYPE
      );
      toogleDropDown();
    }
  };
  const seeMore = () => {
    if (isMobile) showMobileNav = false;
    headerTrigger(ACTIONS.CALL, CALL_OPTIONS.SEE_MORE_STORES);
  };
  function handleClickOutside(event) {
    toogleDropDown();
  }

  // Address Logic
  let formattedAddress;
  const selectAddress = () => {
    if (isMobile) showMobileNav = false;
    headerTrigger(ACTIONS.CALL, CALL_OPTIONS.ADDRESS);
  };
  // Basket logic
  let productBasketNumber;
  const openBasket = () => {
    if (isMobile) showMobileNav = false;
    headerTrigger(ACTIONS.CALL, CALL_OPTIONS.BASKET);
  };

  // Login options
  let optionsOpen = false;
  let isLoggedIn,
    currentUrl,
    logInTitle,
    signUpTitle,
    logOutTitle,
    seeMoreText,
    isPrime,
    userName,
    welcomeText,
    storesTitle,
    userUrl,
    primeUrl,
    subscribeUrl,
    preferencesText,
    rappiCredits,
    rappiCreditsTitle,
    menuOptions,
    primeFirst,
    primeSecond,
    primeSubtitle;

  const toggleLoggedOptions = () => (optionsOpen = !optionsOpen);
  const navigateToLogin = () => navigateToView(NAVIGATE_OPTIONS.LOGIN);
  const navigateToSingUp = () => navigateToView(NAVIGATE_OPTIONS.SIGN_UP);
  const navigateToPrime = () => navigateToOption(NAVIGATE_OPTIONS.PRIME);
  const navigateToRappiCredits = () => {
    toggleLoggedOptions();
    navigateToView(NAVIGATE_OPTIONS.RAPPICREDITS);
  };
  const navigateToOption = (opt) => {
    if (isMobile) {
      showMobileNav = false;
    } else {
      toggleLoggedOptions();
    }
    navigateToView(opt);
  };
  const logOut = () => {
    toggleLoggedOptions();
    if (isMobile) showMobileNav = false;
    headerTrigger(ACTIONS.CALL, CALL_OPTIONS.LOGOUT);
  };
  const getParamValue = (param) => {
    let value = '';
    const params = new URLSearchParams(window.location.search);

    if (params.has("query")) {
      value = params.get('query');
    }

    return value;
  }

  // Footer options
  let footerList;
</script>

<style type="text/scss">
  @import './styles/header';
  @import './styles/global-styles';
  @import './styles/icons';
  @import './styles/inputs';
</style>

<svelte:options tag="header-gema" />
<svelte:window bind:innerWidth={currentWidth} />
{#if !!currentHeader && !!Object.entries(currentHeader).length}
  {#if currentHeader.showHeader}
    {#if !isMobile && !currentHeader.showSpecialBack}
      <div class={!!isOnSpecialStore ? 'header-back special' : 'header-back'} />
    {/if}
    <div id="header-container" class={`header-container ${isMobile && !currentHeader.showAddress ? 'header-regular' : ''}`}>
      {#if showMobileNav && isMobile}
        <div class="mobile-menu-options">
          <div class="user-options-mbl">
            {#if isLoggedIn}
              <div class="user-profile">
                <p class="section-subtitle-menu">{preferencesText}</p>
                <div class="info-user-mbl">
                  <div class="cont-info-user-mbl">
                    <div class="img-cont">
                      <img
                        on:error={(userUrl = errorImg)}
                        class="user-profile-img"
                        src={userUrl}
                        alt="user-profile-image" />
                      {#if isPrime}
                        <img
                          class="prime-micro"
                          src={primeUrl}
                          alt="Logo RappiPrime Crown" />
                      {/if}
                    </div>
                    <p>{welcomeText}<b>{userName}</b></p>
                  </div>
                </div>
              </div>
            {/if}
            {#if !isPrime}
              <div class="subscribe-welcome">
                <img
                  class="subscribe-img"
                  src={subscribeUrl}
                  alt="subscribe-prime-image" />
                <div class="subs-info" on:click={navigateToPrime}>
                  <p>{primeFirst} <b>{primeSecond}</b></p>
                  <b>{primeSubtitle}</b>
                </div>
              </div>
            {/if}
            {#if isLoggedIn}
              <div class="menu-options">
                {#each menuOptions as option}
                  <div
                    class="menu-opt-element"
                    on:click={navigateToOption(option.type)}>
                    {option.text}
                  </div>
                {/each}
              </div>
            {/if}
          </div>
          <div class="store-types-mbl">
            <p class="section-subtitle-menu">{storesTitle}</p>
            <div class="menu-options">
              {#each _mblStoreTypes as option}
                <div class="menu-opt-element" on:click={selectStore(option)}>
                  {option.name}
                </div>
              {/each}
              <div class="menu-opt-element" on:click={seeMore}>
                {seeMoreText}
              </div>
            </div>
          </div>
          <div class="menu-options last">
            {#each footerList as option}
              <div
                class="menu-opt-element footer"
                on:click={navigateToOption(option.type)}>
                {option.text}
              </div>
            {/each}
            {#if isLoggedIn}
              <div class="log-out-mbl" on:click={logOut}>
                <p>{logOutTitle}</p>
              </div>
            {/if}
          </div>
          
        </div>
      {/if}
      <div id="header-up-container" class="up-container">
        <div id="header-left-container" class="left-container">
          {#if isMobile && showBackBtn && !currentHeader.showSpecialBack}
            <div id="header-arrow-back" class="arrow-back">
              <i
                id="header-arrow-back-logo"
                class="iconm-arrow-back"
                on:click={goBack} />
            </div>
          {/if}
          {#if currentHeader.showSpecialBack}
            <div class="main-back-opt" on:click={goSpecialBack}>
              <i class="iconm-arrow_left" />
              <p class="title-back">{specialBackText}</p>
            </div>
          {:else}
            <i
              id="header-rappi-logo"
              class="iconm-rappi-logo logo"
              on:click={goToHome} />
          {/if}
          {#if currentHeader.showStoreType && !isMobile && !!currentStore}
            <div id="header-store-type-container" class="store-type-container">
              <p class="store" on:click={toogleDropDown}>{currentStore.name}</p>
              {#if !!_storeTypes && showDropDown}
                <ul
                  use:clickOutside
                  on:click_outside={handleClickOutside}
                  class="drop-down-menu">
                  {#each _storeTypes as item}
                    <li>
                      <p class="store-type" on:click={selectStore(item)}>
                        {item.name}
                      </p>
                    </li>
                  {/each}
                </ul>
                <i class="iconm-arrow_up arrow up" on:click={toogleDropDown} />
              {:else}
                <i
                  class="iconm-arrow_down_2 arrow down"
                  on:click={toogleDropDown} />
              {/if}
            </div>
          {/if}
          {#if currentHeader.showSearchBar && (!currentHeader.showStoreType || (currentHeader.showStoreType && !!currentStore))}
            <div class={searchStyle} on:keyup={handleSearch}>
              <i on:click={searchOnRappi} class="iconm-compound-search lenss" />
              <input
                size={!!placeHolderText && placeHolderText.length + 5}
                placeholder={placeHolderText}
                bind:value={searchText}
                on:focus={toogleFocus}
                on:blur={toogleFocus} />
              {#if !!searchText && !isMobile}
                <span on:click={clearText} class="cross">&#10005</span>
              {:else if showMblSearch && isMobile}
                <span class="cross" on:click={toogleMblSearch}>{'<'}</span>
              {/if}
              {#if showSuggestions && ((showMblSearch && isMobile) || !isMobile)}
                {#if !!globalSugg && !!globalSugg.length}
                  <div class="search-suggested">
                    <ul class="search-list" id="ul-suggested">
                      {#each globalSugg as item}
                        <li
                          class="item-suggest"
                          on:click={selectSuggestion(item, SELECT_SOURCE.GENERAL)}>
                          <a>{item}</a>
                          <i class="iconm-arrow_right" />
                        </li>
                      {/each}
                    </ul>
                  </div>
                {:else if !!restaurantSugg && !!restaurantSugg.length}
                  <div class="restaurant-suggestions">
                    <ul class="restaurant-sugg-list">
                      {#each restaurantSugg as item}
                        <li
                          class="stores"
                          on:click={selectSuggestion(item, SELECT_SOURCE.RESTAURANT)}>
                          <a class="bg-link-store" />
                          {#if !item.is_open}
                            <div class="store_closed" />
                          {/if}
                          <div class="cont-img-search">
                            <img
                              src={item.url}
                              alt={item.text}
                              on:error={(item.url = errorImg)} />
                          </div>
                          <div class="cont-info-search">
                            <a class="title"> {item.brand_name} </a>
                            <i class="iconm-arrow_right" />
                            {#if !item.is_open}
                              <p class="text-closed">{closedText}</p>
                            {/if}
                          </div>
                        </li>
                      {/each}
                    </ul>
                  </div>
                {/if}
              {/if}
            </div>
          {/if}
        </div>
        <div id="header-right-container" class="right-container">
          {#if currentHeader.showSearchBar && !showMblSearch && isMobile}
            <i
              class="iconm-compound-search mobile-lenss"
              on:click={toogleMblSearch} />
          {/if}
          {#if currentHeader.showAddress && !isMobile}
            <div id="header-user-options" class="user-options">
              <div
                id="header-address-select"
                on:click={selectAddress}
                class="address-select">
                <i class="iconm-position-pin" />
                <p class="formatted-address">{formattedAddress}</p>
                <i class="iconm-arrow_down_2 arrow down" />
              </div>
            </div>
          {/if}
          {#if currentHeader.showBasket}
            <div class="container-new-bascket" on:click={openBasket}>
              <img src="https://gemahub.rappi.com.uy/assets/shopping_cart.svg" alt="basket">
              <span class="product-number">{productBasketNumber}</span>
            </div>
          {/if}
          {#if !isMobile && !currentHeader.showSpecialBack}
            <div id="header-divider" class="divider" />
          {/if}
          {#if currentHeader.showInfoUser && !showMblSearch && !isMobile}
            {#if isLoggedIn}
              <div
                id="header-user-profile"
                class="user-profile"
                on:click={toggleLoggedOptions}>
                <i class="iconm-user-logged user-logo" />
              </div>
              {#if optionsOpen}
                <div on:click={toggleLoggedOptions} class="bg-layer" />
                <div
                  in:fly={{ y: -100, duration: 400 }}
                  out:fade
                  class="user-profile-options">
                  <div class="prime-welcome">
                    <div class="details-container">
                      <div class="profile-img-container">
                        <img
                          on:error={(userUrl = errorImg)}
                          class="user-profile-image"
                          src={userUrl}
                          alt="user-profile-image" />
                        {#if isPrime}
                          <img
                            class="prime-micro"
                            src={primeUrl}
                            alt="Logo RappiPrime Crown" />
                        {/if}
                      </div>
                      <p>{welcomeText}<b>{userName}</b></p>
                    </div>
                  </div>
                  {#if !isPrime}
                    <div class="subscribe-welcome" on:click={navigateToPrime}>
                      <img
                        class="subscribe-img"
                        src={subscribeUrl}
                        alt="subscribe-prime-image" />
                      <div class="subs-info">
                        <p>{primeFirst} <b>{primeSecond}</b></p>
                        <b>{primeSubtitle}</b>
                      </div>
                    </div>
                  {/if}
                  {#if !!rappiCredits}
                    <div class="rappi-credits-container">
                      <p class="rappicredits-title">{rappiCreditsTitle}</p>
                      <div
                        on:click={navigateToRappiCredits}
                        class="rc-available">
                        {rappiCredits}
                      </div>
                    </div>
                  {/if}
                  {#if menuOptions && !!menuOptions.length}
                    <div class="menu-options">
                      {#each menuOptions as option}
                        <div
                          class="menu-opt-element"
                          on:click={navigateToOption(option.type)}>
                          {option.text}
                        </div>
                      {/each}
                    </div>
                  {/if}
                  <div
                    id="header-log-out"
                    class="menu-opt-element log-out-options"
                    on:click={logOut}>
                    {logOutTitle}
                  </div>
                </div>
              {/if}
            {:else}
              <div class="log-in-option" id="header-log-in-option">
                <button
                  on:click={navigateToLogin}
                  class="login-btn">{logInTitle}
                </button>
                <button
                  on:click={navigateToSingUp}
                  class="singUp-btn">{signUpTitle}
                </button>
              </div>
            {/if}
          {/if}
          {#if !isLoggedIn &&  isMobile && !showMblSearch && !currentUrl.includes('/login')}
            <div class="log-in-option" id="header-log-in-option">
              <button on:click={navigateToLogin} class="login-btn">{logInTitle}
              </button>
            </div>
          {/if}
          {#if currentHeader.showStoreType && isMobile}
            <div
              on:click={toogleMobileNav}
              class={`stores-burguer ${showMobileNav ? 'open' : ''}`}>
              <div class="menu-line" />
              <div class="menu-line" />
              <div class="menu-line" />
            </div>
          {/if}
        </div>
      </div>
      {#if isMobile && currentHeader.showAddress}
        <div id="header-down-container" class="down-container">
          <div class="address-mbl" on:click={selectAddress}>
            <p class="formatted-address mbl">{formattedAddress}</p>
            <i class="iconm-arrow_down_2" />
          </div>
        </div>
      {/if}
    </div>
  {/if}
{/if}
